<template>
  <component
    :is="tag"
    :type="tag === 'button' ? 'button' : undefined"
    :data-test-id="dataTestId"
    :class="rootClass"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import { twMerge } from 'tailwind-merge'

const {
  isActive = false,
  dataTestId,
  tag = 'div',
  showInactiveHover = false,
} = defineProps<{
  isActive?: boolean
  dataTestId?: string
  tag?: 'div' | 'button'
  showInactiveHover?: boolean
}>()

const attrs = useAttrs()

const rootClass = computed(() =>
  twMerge(
    'flex gap-3 items-stretch rounded-lg border-2 p-3 transition-colors',
    isActive ? 'border-teal-500 bg-teal-50/80' : 'border-gray-100 bg-white',
    !isActive && showInactiveHover ? 'hover:bg-gray-100' : undefined,
    tag === 'button' ? 'w-full cursor-pointer' : undefined,
    attrs.class as string | undefined
  )
)
</script>
